import { ObjectFieldsChecker } from "../../../../../../../tools/ObjectFieldsChecker";
import { MintConfig } from "../../../../../../../web3/MintConfig";
import { PrepareMintResultDto } from "../../../../../../networking/data/responses/marketplace/buildings/PrepareMintResultDto";

export class PrepareMintResult {
    public readonly mintConfig: MintConfig;
    public readonly signature: string;
    public readonly totalPrice: string;

    public constructor(dto: PrepareMintResultDto) {
        ObjectFieldsChecker.throwIfInvalidFields(dto, [
            "mintRequest",
            "signature",
            "totalPrice"

        ]);
        ObjectFieldsChecker.throwIfInvalidFields(dto.mintRequest, [
            "currency",
            "price",
            "primarySaleRecipient",
            "royaltyBps",
            "royaltyRecipient",
            "to",
            "uid",
            "uri",
            "validityEndTimestamp",
            "validityStartTimestamp"
        ]);
        const mintRequest = dto.mintRequest;
        const mintConfig = {
            to: mintRequest.to,
            royaltyRecipient: mintRequest.royaltyRecipient,
            royaltyBps: mintRequest.royaltyBps,
            primarySaleRecipient: mintRequest.primarySaleRecipient,
            uri: mintRequest.uri,
            price: mintRequest.price,
            currency: mintRequest.currency,
            validityStartTimestamp: mintRequest.validityStartTimestamp,
            validityEndTimestamp: mintRequest.validityEndTimestamp,
            uid: mintRequest.uid
        }
        return {
            mintConfig: mintConfig,
            signature: dto.signature,
            totalPrice: dto.totalPrice
        };
    }
}
